<template>
    <div>        
        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-6 p-md-6">
                        <label>Empresa (Status)</label>
                     <Dropdown v-model.number="status" :options="tiposStatus" optionLabel="nome" optionValue="valor" placeholder="Status"/>
                    </div>  
                       <div class="p-field p-col-0">
                        <label style="color:#ffffff">.</label>  
                        <Button label="Buscar" icon="pi pi-search" @click="buscarClientes()"/>
                    </div>                                    
                </div>
            </div>
        </div>
        <PickList v-model="clientes" listStyle="height:300px" dataKey="id">
            <template #sourceHeader>
                Clientes Disponíveis
            </template>
            <template #targetHeader>
                Clientes Selecionados
            </template>
            <template #item="slotProps">
               <div>
                   {{slotProps.item.nome}}
               </div>
           </template> 
        </PickList>
    </div>
</template>

<script>
import EmpresaService from '@/service/EmpresaService';
import { exibirMensagem, exibirMensagemSis } from '@/global';
import { mapGetters } from 'vuex';

export default {
    empresaService: null,  
    data() {
        return { 
            tiposStatus: [],
            cliente:{},
            status: null,
            clientes: null
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),        
        buscarClientes(){
            if(this.status == null) {
                exibirMensagemSis(this, 'Selecione um status', true);
                return;
            }
            let requisicao = {               
                status: this.status,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };               
            this.empresaService.buscarClientes(requisicao)
                .then(resp => {                                          
                    this.clientes = [resp.data, []];                  
                })
                .catch(erro => {exibirMensagem(this, erro)});
                       
        },
        carregarTiposStatus() {
            this.tiposStatus.push({nome: "Ativo", valor: 1});
            this.tiposStatus.push({nome: "Bloqueado", valor: 2});
            this.tiposStatus.push({nome: "Inativo", valor: 0});
        },
         getClientes() {
            let dados = {
                clientes: [],
                status: this.status,
            };
            if(this.clientes == null) {
               return dados;
            }   
            dados.clientes = this.clientes[1];
            return dados;
        }
    },
    created() {
        this.empresaService = new EmpresaService();       
    },
    mounted() {
        this.carregarTiposStatus();
    }
}
</script>

<style>

</style>